/* Inspiration — 갤러리·모달 공용 동작 (2026-08-18).
   ⚠️ 모달은 클릭 시점에 Section Rendering API로 가져온다(사전 렌더 금지 — 룩 112개 × 모달 = 페이지 폭증).
   ⚠️ innerHTML 주입은 <script>를 실행하지 않는다 → 모든 핸들러는 document 위임으로 여기에만 둔다.
   ⚠️ 테마 JS(jQuery·magnific)는 뒤에 로드될 수 있다 → 조기 return 금지, 클릭 순간에 조회. */
(function () {
    var cache = {};                       // handle → 모달 HTML

    function up(node, cls) {
        while (node && node !== document) {
            if (node.classList && node.classList.contains(cls)) return node;
            node = node.parentNode;
        }
        return null;
    }

    function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

    function holder() {
        var h = document.getElementById('ig-modal-holder');
        if (!h) {
            h = document.createElement('div');
            h.id = 'ig-modal-holder';
            document.body.appendChild(h);
        }
        return h;
    }

    function show(html) {
        var h = holder();
        h.innerHTML = html;
        var el = h.querySelector('.ig-modal');
        if (!el) return;
        var $ = window.jQuery;
        if ($ && $.magnificPopup) {
            $.magnificPopup.open({
                items: { src: $(el), type: 'inline' },
                mainClass: 'mfp-zoom-in ig-mfp',
                removalDelay: 250, closeBtnInside: false, showCloseBtn: false
            });
        } else {
            el.classList.add('ig-modal--fallback');   // 라이브러리 없어도 열린다
            document.body.classList.add('ig-open');
        }
    }

    function close() {
        var $ = window.jQuery;
        if ($ && $.magnificPopup) $.magnificPopup.close();
        var f = document.querySelector('.ig-modal--fallback');
        if (f) f.classList.remove('ig-modal--fallback');
        document.body.classList.remove('ig-open');
        var h = document.getElementById('ig-modal-holder');
        if (h) h.innerHTML = '';
    }

    function openLook(card) {
        var handle = card.getAttribute('data-ig-handle');
        if (!handle) return;
        if (cache[handle]) { show(cache[handle]); return; }
        card.classList.add('is-loading');
        fetch(root() + 'pages/' + handle + '?section_id=inspiration-modal', { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
                cache[handle] = html;
                card.classList.remove('is-loading');
                show(html);
            })
            .catch(function () {
                card.classList.remove('is-loading');
                window.location.href = root() + 'pages/' + handle;   // 실패 시 룩 페이지로
            });
    }

    function addToCart(ids, done) {
        fetch(root() + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
        }).then(function (r) { return r.json(); }).then(function (res) {
            if (res && res.status && res.status !== 200) { alert(res.description || res.message); done(false); return; }
            if (window.ajaxCart && window.ajaxCart.load) window.ajaxCart.load();
            document.dispatchEvent(new CustomEvent('postera:cart-updated'));   // 무료배송 배너 갱신
            done(true);
        }).catch(function () { done(false); });
    }

    function openCartDrawer() {
        var t = document.querySelector('.js-cart-trigger') || document.querySelector('.js-cart-icon');
        if (t) t.click();
    }

    /* ── 카드 노출 제어 — 최초 N개만, 스크롤/버튼으로 N개씩 추가 (Young 2026-08-18) ── */
    var state = { rooms: [], shown: 0, size: 30 };   // rooms = 선택 집합(빈 배열 = 전체)

    function grid() { return document.querySelector('.ig__grid'); }

    function render() {
        var g = grid();
        if (!g) return;
        var cards = g.querySelectorAll('.ig-card');
        var matched = 0, visible = 0;
        for (var i = 0; i < cards.length; i++) {
            var hit = !state.rooms.length || state.rooms.indexOf(cards[i].getAttribute('data-ig-room')) >= 0;
            if (hit) {
                matched++;
                var show = matched <= state.shown;
                cards[i].classList.toggle('ig-card--hidden', !show);
                if (show) visible++;
            } else {
                cards[i].classList.add('ig-card--hidden');
            }
        }
        var more = document.querySelector('.js-ig-more');
        if (more) more.hidden = visible >= matched;
        var count = document.querySelector('.js-ig-count');
        if (count) count.textContent = visible + ' / ' + matched;
    }

    function loadMore() { state.shown += state.size; render(); }

    function initPaging() {
        var wrap = document.querySelector('.ig[data-ig-page-size]');
        if (!wrap) return;
        state.size = Number(wrap.getAttribute('data-ig-page-size')) || 30;
        state.shown = state.size;
        render();
        var sentinel = document.querySelector('.js-ig-sentinel');
        if (sentinel && window.IntersectionObserver) {
            new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting) {
                    var more = document.querySelector('.js-ig-more');
                    if (more && !more.hidden) loadMore();       // 버튼이 살아 있을 때만 = 남은 게 있을 때만
                }
            }, { rootMargin: '400px 0px' }).observe(sentinel);
        }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPaging);
    else initPaging();

    document.addEventListener('click', function (e) {
        if (up(e.target, 'js-ig-more')) { e.preventDefault(); loadMore(); return; }

        var card = up(e.target, 'js-ig-open');
        if (card) { e.preventDefault(); openLook(card); return; }

        if (up(e.target, 'js-ig-close')) { e.preventDefault(); close(); return; }

        var one = up(e.target, 'js-ig-add-one');
        if (one) {
            e.preventDefault();
            addToCart([one.getAttribute('data-ig-id')], function (ok) { if (ok) one.classList.add('is-added'); });
            return;
        }

        var all = up(e.target, 'js-ig-add-all');
        if (all) {
            e.preventDefault();
            var modal = up(all, 'ig-modal');
            var ids = ((modal && modal.getAttribute('data-ig-ids')) || '').split(',').filter(Boolean);
            if (!ids.length) return;
            all.setAttribute('disabled', 'disabled');
            addToCart(ids, function (ok) {
                all.removeAttribute('disabled');
                if (ok) { close(); setTimeout(openCartDrawer, 320); }
            });
            return;
        }

        var chip = up(e.target, 'ig-chip');
        if (chip) {
            e.preventDefault();
            // 다중 선택·토글(Young 2026-09-13): 선택 집합이 비면 전체 노출(옛 All 칩 역할)
            var key = chip.getAttribute('data-ig-room') || '';
            var idx = state.rooms.indexOf(key);
            if (idx >= 0) state.rooms.splice(idx, 1); else state.rooms.push(key);
            chip.classList.toggle('is-active', idx < 0);
            state.shown = state.size;              // 필터 바꾸면 다시 처음 N개부터
            render();
            return;
        }

        var nav = up(e.target, 'js-ig-prev') || up(e.target, 'js-ig-next');
        var dot = up(e.target, 'ig-dot');
        if (nav || dot) {
            e.preventDefault();
            var scene = up(nav || dot, 'ig-scene');
            var track = scene.querySelector('.js-ig-track');
            var slides = track.children.length;
            var cur = Number(track.getAttribute('data-ig-cur') || 0);
            if (dot) cur = Number(dot.getAttribute('data-ig-slide'));
            else cur = up(e.target, 'js-ig-next') ? (cur + 1) % slides : (cur - 1 + slides) % slides;
            track.setAttribute('data-ig-cur', cur);
            track.style.transform = 'translateX(' + (-100 * cur) + '%)';
            var dots = scene.querySelectorAll('.ig-dot');
            for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === cur);
        }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
